// extracted by mini-css-extract-plugin
export default {"container":"lA-z"};